import { ShieldCheck, ShieldAlert, ShieldX } from 'lucide-react';

// Esito dell'evento: l'azione ostile è stata fermata da un controllo, è rimasta un tentativo, o è
// andata a segno? (backend: services/eventOutcome.ts). Usato in Security Alerts, Security
// Incidents e nella coda di SOC Operations, così la stessa informazione ha sempre lo stesso aspetto.
//
// Colore MAI da solo: ogni badge porta icona e testo. Sono stati, non categorie, quindi seguono la
// semantica dei semafori (verde = fermato, ambra = tentato, rosso = riuscito) — la stessa logica
// usata per le severità altrove in piattaforma.
//
// Quando il backend non riesce a determinare l'esito restituisce null e qui non si mostra nulla:
// meglio un'assenza che un'etichetta inventata su un dato di sicurezza.
export type EventOutcome = 'blocked' | 'attempted' | 'succeeded';

const OUTCOME_STYLE: Record<EventOutcome, { label: string; className: string; Icon: typeof ShieldCheck; title: string }> = {
  blocked: {
    label: 'Bloccato',
    className: 'bg-emerald-100 text-emerald-800',
    Icon: ShieldCheck,
    title: "L'apparato che ha generato l'evento riporta di aver bloccato l'azione",
  },
  attempted: {
    label: 'Tentato',
    className: 'bg-amber-100 text-amber-800',
    Icon: ShieldAlert,
    title: "L'azione risulta tentata ma non completata (es. autenticazione fallita)",
  },
  succeeded: {
    label: 'Riuscito',
    className: 'bg-red-100 text-red-700',
    Icon: ShieldX,
    title: "Nessun controllo risulta aver fermato l'azione: da verificare con priorità",
  },
};

export default function OutcomeBadge({ outcome, className = '' }: { outcome: EventOutcome | null | undefined; className?: string }) {
  if (!outcome) return null;
  const style = OUTCOME_STYLE[outcome];
  if (!style) return null;
  const { label, className: tone, Icon, title } = style;
  return (
    <span className={`badge ${tone} inline-flex items-center gap-1 ${className}`} title={title}>
      <Icon size={11} /> {label}
    </span>
  );
}
